import { Modal, Button } from "antd";

interface IProps {
    openModal: boolean;
    setOpenModal: Function;
}

export const ModalInformacion: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setOpenModal(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.openModal}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ textAlign: 'left', fontSize: '1.2em' }}>
        <p style={{ fontSize: '1.5em', fontWeight: 'bold', textAlign: 'center' }}>
          ¡Atención!
        </p>
        <p>
          Debido al número total alcanzado en las postulaciones y contemplando algunos comentarios de los verificadores, se realizaron las siguientes actualizaciones:
        </p>
        <p>
          1. Ya no se debe esperar a que carguen todas las postulaciones. Ingresar código o número de documento, o si va consultar toda una línea seleccionarla y darle clic en "Buscar".
        </p>
        <p>
          2. Al momento de guardar algún estado u observación el cambio se verá reflejado de inmediato sin necesidad de refrescar.
        </p>
        <p>
          Atentamente, <br />
          Equipo de Convocatorias de la Secretaría de Cultura Ciudadana
        </p>
      </div>
    </Modal>
  );
};
